import { Backdrop, CircularProgress, Typography, Box, AppBar, Toolbar, Avatar, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import TicketList from "./TicketList";
import { AssignedTicketsDevloper, CompletedTicketsDevloper } from "../viewmodel/FetchTicketsDeveloper";
import FilterView from "./FilterView";
import PaginationView from "./PaginationView";

// Icons for consistent Modern UI
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import SearchIcon from '@mui/icons-material/Search';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';

// CONAS Brand Colors
const CONAS_BLUE = "#163672";
const CONAS_GREEN = "#69b244";

function DeveloperMainLayout() {
    let filterReset = {
        ticketId: "", ticketHeading: null, ticketTool: null,
        ticketDate: null, ticketStatus: null, ticketType: null,
    }
    const [screen, setScreen] = useState("assigned")
    const [ticketData, setTicketData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [filterData, setFilterData] = useState({
        ticketId: null, ticketHeading: null, ticketTool: null,
        ticketDate: null, ticketStatus: null, ticketType: null,
    })
    const [filterDataToSend, setFilterDataToSend] = useState({})
    const [totalDataCount, setTotalDataCount] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)

    const handelassignedTickets = async () => {
        setLoading(true)
        setScreen("assigned")
        setFilterData(filterReset)
        setFilterDataToSend(filterReset)
        setCurrentPage(1)
        let response = await AssignedTicketsDevloper(filterReset, 1)
        setTicketData(response.data.ticket_data)
        setTotalDataCount(Math.ceil(response.data.totalCount / 2))
        setLoading(false)
    }

    const handelCompletedTicket = async () => {
        setLoading(true)
        setScreen("completed")
        setFilterData(filterReset)
        setFilterDataToSend(filterReset)
        setCurrentPage(1)
        let response = await CompletedTicketsDevloper(filterReset, 1)
        setTicketData(response.data.ticket_data)
        setTotalDataCount(Math.ceil(response.data.totalCount / 2))
        setLoading(false)
    }

    const handelFilterSubmitClick = async () => {
        setFilterDataToSend({ ...filterData })
        setCurrentPage(1)
        if (screen === "assigned") {
            let response = await AssignedTicketsDevloper(filterData, 1)
            setTicketData(response.data.ticket_data)
            setTotalDataCount(Math.ceil(response.data.totalCount / 2))
        } else if (screen === "completed") {
            let response = await CompletedTicketsDevloper(filterData, 1)
            setTicketData(response.data.ticket_data)
            setTotalDataCount(Math.ceil(response.data.totalCount / 2))
        }
    }

    const NextButtonClick = async () => {
        setLoading(true)
        let nextpage = currentPage + 1
        setCurrentPage((prev) => prev + 1)
        if (screen === "assigned") {
            let response = await AssignedTicketsDevloper(filterDataToSend, nextpage)
            setTicketData(response.data.ticket_data)
        } else if (screen === "completed") {
            let response = await CompletedTicketsDevloper(filterDataToSend, nextpage)
            setTicketData(response.data.ticket_data)
        }
        setLoading(false)
    }

    const PrevButtonClick = async () => {
        setLoading(true)
        let previous = currentPage - 1
        setCurrentPage((prev) => prev - 1)
        if (screen === "assigned") {
            let response = await AssignedTicketsDevloper(filterDataToSend, previous)
            setTicketData(response.data.ticket_data)
        } else if (screen === "completed") {
            let response = await CompletedTicketsDevloper(filterDataToSend, previous)
            setTicketData(response.data.ticket_data)
        }
        setLoading(false)
    }

    const handlePageClick = async (page) => {
        setLoading(true)
        setCurrentPage(page)
        if (screen === "assigned") {
            let response = await AssignedTicketsDevloper(filterDataToSend, page)
            setTicketData(response.data.ticket_data)
        } else if (screen === "completed") {
            let response = await CompletedTicketsDevloper(filterDataToSend, page)
            setTicketData(response.data.ticket_data)
        }
        setLoading(false)
    }

    const handelFilterClearClick = () => {
        if (screen == "assigned") handelassignedTickets()
        else if (screen == "completed") handelCompletedTicket()
    }

    useEffect(() => {
        const load = async () => {
            setLoading(true)
            let response = await AssignedTicketsDevloper(filterData, 1)
            setTicketData(response.data.ticket_data);
            setTotalDataCount(Math.ceil(response.data.totalCount / 2))
            setLoading(false)
        }
        load()
    }, [])

    // Reusable Navigation Item Component for Sidebar
    const NavItem = ({ title, icon, activeScreen, onClick }) => {
        const isActive = screen === activeScreen;
        return (
            <Box onClick={onClick} sx={{
                display: "flex", alignItems: "center", gap: 2,
                px: 2.5, py: 1.5, mx: 1.5, my: 0.5,
                borderRadius: "10px", cursor: "pointer",
                backgroundColor: isActive ? "rgba(255,255,255,0.1)" : "transparent",
                color: isActive ? "#ffffff" : "rgba(255,255,255,0.6)",
                borderLeft: isActive ? `4px solid ${CONAS_GREEN}` : "4px solid transparent",
                transition: "all 0.2s ease-in-out",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.1)", color: "#ffffff" }
            }}>
                {icon}
                <Typography sx={{ fontWeight: isActive ? 600 : 500, fontSize: "0.95rem" }}>{title}</Typography>
            </Box>
        )
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100vw', overflow: 'hidden', backgroundColor: "#f0f4f8" }}>
            
            {/* Sleek Top Toolbar */}
            <AppBar position="static" elevation={0} sx={{ backgroundColor: "white", borderBottom: "1px solid #e2e8f0", zIndex: 10 }}>
                <Toolbar sx={{ minHeight: "64px !important", display: "flex", justifyContent: "space-between", px: { xs: 2, md: 4 } }}>
                    
                    {/* Mobile Logo */}
                    <Box sx={{ display: { xs: "flex", lg: "none" }, alignItems: "center", gap: 1 }}>
                        <ConfirmationNumberIcon sx={{ color: CONAS_BLUE, fontSize: 26, transform: "rotate(-15deg)" }} />
                        <Typography variant="h6" sx={{ color: CONAS_BLUE, fontWeight: 800, letterSpacing: "-0.5px" }}>CONAS</Typography>
                    </Box>
                    
                    {/* Search Bar Placeholder */}
                    <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", backgroundColor: "#f1f5f9", px: 2, py: 1, borderRadius: "8px", width: "300px" }}>
                        <SearchIcon sx={{ color: "#94a3b8", fontSize: 20, mr: 1 }} />
                        <Typography sx={{ color: "#94a3b8", fontSize: "0.9rem" }}>Search workspace...</Typography>
                    </Box>

                    <Box sx={{ flexGrow: { xs: 1, md: 0 } }} /> 
                    
                    {/* Right Side Icons */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                        <IconButton size="small" sx={{ color: "#64748b", bgcolor: "#f8fafc", "&:hover": { bgcolor: "#f1f5f9" } }}>
                            <NotificationsNoneIcon />
                        </IconButton>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, pl: 3, borderLeft: "1px solid #e2e8f0" }}>
                            <Avatar sx={{ width: 36, height: 36, bgcolor: CONAS_GREEN, fontSize: "14px", fontWeight: "bold" }}>D</Avatar>
                            <Box sx={{ display: { xs: "none", sm: "block" } }}>
                                <Typography variant="body2" sx={{ fontWeight: 700, color: "#1e293b", lineHeight: 1.1 }}>Developer</Typography>
                                <Typography variant="caption" sx={{ color: "#64748b" }}>Workspace</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>

            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: { xs: "column", lg: "row" }, overflow: "hidden" }}>
                
                {/* Premium Sidebar */}
                <Box sx={{ 
                    width: { lg: "260px", xs: "100%" }, backgroundColor: CONAS_BLUE, height: "100%",
                    display: "flex", flexDirection: { xs: "row", lg: "column" }, flexShrink: 0,
                    overflowX: { xs: "auto", lg: "visible" }, overflowY: "auto",
                    borderBottom: { xs: "1px solid rgba(255,255,255,0.1)", lg: "none" },
                    boxShadow: { lg: "4px 0 24px rgba(0,0,0,0.05)" }, zIndex: 5,
                    '&::-webkit-scrollbar': { height: '0px', width: '0px' }
                }}>
                    <Box sx={{ display: { xs: "none", lg: "flex" }, alignItems: "center", gap: 2, p: 3, pt: 4, mb: 1 }}>
                        <Box sx={{ backgroundColor: "rgba(255,255,255,0.1)", borderRadius: "10px", p: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <DashboardCustomizeIcon sx={{ color: CONAS_GREEN, fontSize: 28 }} />
                        </Box>
                        <Box>
                            <Typography variant="h6" sx={{ color: "white", fontWeight: 800, letterSpacing: "-0.5px", lineHeight: 1.2 }}>Ticketing</Typography>
                            <Typography variant="caption" sx={{ color: CONAS_GREEN, fontWeight: 600, letterSpacing: "1px", textTransform: "uppercase" }}>Workspace</Typography>
                        </Box>
                    </Box>

                    <Typography variant="caption" sx={{ display: { xs: "none", lg: "block" }, color: "rgba(255,255,255,0.4)", fontWeight: 700, px: 4, mb: 1, mt: 2, textTransform: "uppercase", letterSpacing: "1px" }}>Menu</Typography>

                    <Box sx={{ display: "flex", flexDirection: { xs: "row", lg: "column" }, flexGrow: 1, minWidth: "max-content", py: { xs: 1, lg: 0 } }}>
                        <NavItem title="Assigned Tickets" icon={<AssignmentIndIcon fontSize="small" />} activeScreen="assigned" onClick={handelassignedTickets} />
                        <NavItem title="Completed Tickets" icon={<TaskAltIcon fontSize="small" />} activeScreen="completed" onClick={handelCompletedTicket} />
                    </Box>
                </Box>

                {/* Main Content Area - Locked Height, Independent Scroll */}
                <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", overflowX: "hidden" }}>
                    <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "flex-start" }}>
                        
                        <Box sx={{ width: "100%", maxWidth: "1200px", display: "flex", flexDirection: "column", gap: 3 }}>
                            
                            <Box sx={{ backgroundColor: "white", p: { xs: 2, md: 3 }, borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 4px 20px rgba(0,0,0,0.02)" }}>
                                <FilterView filterData={filterData} usertype={"Admin"} setFilterData={setFilterData} handelFilterSubmitClick={handelFilterSubmitClick} handelFilterClearClick={handelFilterClearClick} />
                            </Box>
                            
                            {!loading && ticketData && (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                    <TicketList ticketData={ticketData} usertype={"Developer"} screen={screen} handelassignedTickets={handelassignedTickets} />
                                    <PaginationView currentPage={currentPage} PrevButtonClick={PrevButtonClick} NextButtonClick={NextButtonClick} totalDataCount={totalDataCount} setCurrentPage={handlePageClick} />
                                </Box>
                            )}
                        </Box>

                    </Box>
                </Box>

            </Box>

            <Backdrop open={loading} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Box>
    )
}

export default DeveloperMainLayout;